import { isInJestMode } from '@dxb-web-ui-framework/common/domain/Environment/EnvironmentService';
import { appBootstrappingHandlers } from './journeys/appBootstrappingJourney';
import { dashboardHandlers } from './journeys/dashboard';
import { userHandlers } from './journeys/user';
import { deviceHandlers } from './journeys/device';
import { orderHandlers } from './journeys/order';
import { onboardingHandlers } from './journeys/onboarding';
import { transfersHandlers } from './journeys/transfers';
import {
  cardsHandler,
  issueCardHandler,
  issueCorporateCardHandler,
  topupCardHandler,
  terminateCardHandler,
  replaceCardHandler,
  permanentBlockCardHandler,
} from './journeys/cards';
import { accountHandlers } from './journeys/account';
import { activityLogHandlers } from './journeys/activityLog';
import { payrollHandlers } from './journeys/payroll';

const params = new URLSearchParams(window.location.search);
const mocksOff = params.get('mocksOff');

const handlers =
  !mocksOff || isInJestMode()
    ? [
        ...appBootstrappingHandlers,
        ...dashboardHandlers,
        ...userHandlers,
        ...deviceHandlers,
        ...orderHandlers,
        ...onboardingHandlers,
        ...transfersHandlers,
        ...cardsHandler,
        ...issueCardHandler,
        ...topupCardHandler,
        ...terminateCardHandler,
        ...replaceCardHandler,
        ...accountHandlers,
        ...activityLogHandlers,
        ...payrollHandlers,
        ...issueCorporateCardHandler,
        ...permanentBlockCardHandler,
      ]
    : [];

export { handlers };
